import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogData } from 'listing-angular15';
import { CookieService } from 'ngx-cookie-service';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';

import { ApiservicesService } from 'src/app/services/apiservices.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AstroService } from 'src/app/services/astro.service';
import { comingsoonModal } from 'src/app/admin-dashboard/user-list/user-list.component';
import { lastValueFrom } from 'rxjs';

interface Payload {
  limit: number;
  skip: number;
  sort: { field: string; type: string };
  user_id?: string;
}

export interface ZodiacCard {
  id: number;
  name: string;
  dateRange: string;
  description: string;
  imageUrl: string;
  signUrl: string;
  locked: boolean;
  unlockDate?: string;
}
@Component({
  selector: 'app-mystery-school-dashboard',
  templateUrl: './mystery-school-dashboard.component.html',
  styleUrls: ['./mystery-school-dashboard.component.scss'],
})
export class MysterySchoolDashboardComponent {
  public cookieData: any = {};

  astro: { sign: string; decan: string; range: string; theme: String } | null =
    null;
  today = new Date();
  currentMonthDay = this.formatMonthDay(this.today);

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public cookieService: CookieService,
    private apiService: ApiservicesService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    private astroService: AstroService,
    private cdr: ChangeDetectorRef
  ) {
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );

    console.log('cookieData', this.cookieData);
  }

  public loader: boolean = false;
  public slotLoader: boolean = false;

  public contentCount: any;

  public calendarData: any = [];

  public limit: number = 5;
  public skip: number = 0;
  public hasMore: boolean = true;

  public trainingLessonData: any = {};

  private imageBase = '../../../assets/images/mystery-dashboard-images/';

  zodiacCards: ZodiacCard[] = [
  {
    id: 1,
    name: 'Aries',
    dateRange: 'MAR 21 - APR 19',
    description: 'THE SPARK OF CREATION AND UNYIELDING INITIATIVE.',
    imageUrl: this.imageBase + 'mystery_wheelcard_aries.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_aries.webp',
    locked: false,
  },
  {
    id: 2,
    name: 'Taurus',
    dateRange: 'APR 20 - MAY 20',
    description: 'GROUNDING ENERGY AND CULTIVATING RESOURCES.',
    imageUrl: this.imageBase + 'mystery_wheelcard_taurus.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_tauras.webp',
    locked: false,
  },
  {
    id: 3,
    name: 'Gemini',
    dateRange: 'MAY 21 - JUN 20',
    description: 'COMMUNICATION, CURIOSITY, AND INTELLECTUAL EXCHANGE.',
    imageUrl: this.imageBase + 'mystery_wheelcard_gemini.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_gemini.webp',
    locked: false,
  },
  {
    id: 4,
    name: 'Cancer',
    dateRange: 'JUN 21 - JUL 22',
    description: 'NURTURING EMOTIONS AND CONNECTING WITH INTUITION.',
    imageUrl: this.imageBase + 'mystery_wheelcard_cancer.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_cancer.webp',
    locked: false, 
  },
  {
    id: 5,
    name: 'Leo',
    dateRange: 'JUL 23 - AUG 22',
    description: 'RADIATING CREATIVITY AND EXPRESSING THE SELF.',
    imageUrl: this.imageBase + 'mystery_wheelcard_leo.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_leo.webp',
    locked: true,
    unlockDate: 'JUL 16'
  },
  {
    id: 6,
    name: 'Virgo',
    dateRange: 'AUG 23 - SEP 22',
    description: 'REFINING DETAILS AND DEDICATING TO SERVICE.',
    imageUrl: this.imageBase + 'mystery_wheelcard_virgo.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_virgo.webp',
    locked: true,
    unlockDate: 'AUG 20'
  },
  {
    id: 7,
    name: 'Libra',
    dateRange: 'SEP 23 - OCT 22',
    description: 'SEEKING BALANCE, HARMONY, AND RELATIONSHIPS.',
    imageUrl: this.imageBase + 'mystery_wheelcard_libra.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_libra.webp',
    locked: true,
    unlockDate: 'SEP 25'
  },
  {
    id: 8,
    name: 'Scorpio',
    dateRange: 'OCT 23 - NOV 21',
    description: 'EXPLORING DEPTH, TRANSFORMATION, AND POWER.',
    imageUrl: this.imageBase + 'mystery_wheelcard_scorpio.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_scorpio.webp',
    locked: true,
    unlockDate: 'OCT 25'
  },
  {
    id: 9,
    name: 'Sagittarius',
    dateRange: 'NOV 22 - DEC 21',
    description: 'EXPANDING HORIZONS THROUGH PHILOSOPHY AND ADVENTURE.',
    imageUrl: this.imageBase + 'mystery_wheelcard_sagitarius.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_saggitarius.webp',
    locked: true,
    unlockDate: 'NOV 15'
  },
  {
    id: 10,
    name: 'Capricorn',
    dateRange: 'DEC 22 - JAN 19',
    description: 'BUILDING STRUCTURE AND ACHIEVING MASTERY.',
    imageUrl: this.imageBase + 'mystery_wheelcard_capricorn.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_capricorn.webp',
    locked: true,
    unlockDate: 'DEC 20'
  },
  {
    id: 11,
    name: 'Aquarius',
    dateRange: 'JAN 20 - FEB 18',
    description: 'INNOVATING FOR THE FUTURE AND CONNECTING WITH COMMUNITY.',
    imageUrl: this.imageBase + 'mystery_wheelcard_aquarius.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_aquarius.webp',
    locked: false,
  },
  {
    id: 12,
    name: 'Pisces',
    dateRange: 'FEB 19 - MAR 20',
    description: 'DISSOLVING BOUNDARIES AND CONNECTING WITH THE UNIVERSE.',
    imageUrl: this.imageBase + 'mystery_wheelcard_pisces.webp',
    signUrl: this.imageBase + 'mystery_zodiacsign_pisces.webp',
    locked: false,
  },
];

  ngOnInit() {
    this.today = new Date('2024-11-19'); // any date you want

    this.currentMonthDay = this.formatMonthDay(this.today);

    this.astro = this.astroService.getCurrentAstroPosition(this.today);

    this.activatedRoute.data.subscribe((response: any) => {
      console.log('activatedRoute', response);
      if (response.response.status === 'success') {
        this.trainingLessonData = response?.response?.results?.res
          ? response.response.results.res
          : [];
        console.log(this.trainingLessonData);
      }
    });

    this.loadPage();
    this.getContentCount();
  }

  get displayPercentage(): number {
    const p = this.trainingLessonData?.percentage ?? 0;
    if (p <= 0) return 0;
    if (p >= 100) return 100;
    return p;
  }

  goToLesson(trainingId: any) {
    this.router.navigateByUrl(
      `mystery-school-dashboard/training-lessons/${trainingId}`
    );
  }

  loadPage() {
    this.slotLoader = true;
    const payload: Payload = {
      limit: this.limit,
      skip: this.skip,
      sort: { field: 'updatedAt', type: 'asc' },
      user_id: this.cookieData?.userinfo?._id,
    };

    this.apiService
      .getHttpDataPost('event/available-event-slot-list', payload)
      .subscribe({
        next: (response) => {
          this.hasMore = response.results.length === this.limit;
          if (this.skip > 0) {
            this.calendarData = [...this.calendarData, ...response.results];
          } else {
            this.calendarData = response.results;
          }
          this.slotLoader = false;
        },
        error: () => {
          this.slotLoader = false;
        },
      });
  }

  loadMore() {
    this.skip += this.limit;
    this.loadPage();
  }

  getContentCount() {
    this.apiService.getHttpData('content/content-type-counts').subscribe({
      next: (response) => {
        console.log(response);
        this.contentCount = response.counts;
        console.log(response);
      },
      error: (error) => {},
    });
  }

  unsubscribeOpen() {
    if (!this.cookieData?.userinfo?.mystery_subscription_id) {
      this.matSnackBar.open(
        'Subscription information is missing. Cannot proceed.',
        '',
        { duration: 5000 }
      );
      return;
    }

    const dialogRef = this.dialog.open(MysterySubscriptionModal, {
      panelClass: ['custom-modalbox', 'mystery-subscription-modalbox'],
      data: {
        subscription_id: this.cookieData.userinfo.mystery_subscription_id,
        expiry_date: this.cookieData.userinfo.mystery_current_period_end,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed with result:', result);
      if (result === true) {
        let oldcookie = JSON.parse(
          this.cookieService.get('login_user_details')
        );
        let newcookie = {
          lastLoginTime: oldcookie.lastLoginTime,
          token: oldcookie.token,
          token_expiry: oldcookie.token_expiry,
          userinfo: {
            ...oldcookie.userinfo,
            mystery_subscription_status: false,
          },
        };
        console.log('newcookie', newcookie);
        this.cookieService.set(
          'login_user_details',
          JSON.stringify(newcookie),
          { path: '/' }
        );
        this.cookieData = newcookie;
        this.matSnackBar.open(
          'Unsubscription initiated successfully. Access remains until expiry.',
          'Ok',
          { duration: 5000 }
        );
      }
    });
  }

  subscribeOpen() {
    this.loader = true;
    const body = {
      customer_email: this.cookieData.userinfo.email,
      user_id: this.cookieData.userinfo._id,
    };

    this.apiService
      .getHttpDataPost('stripe/create-subscription-mystery-school', body)
      .subscribe({
        next: (response: any) => {
          if (response.status === 'success' && response.results) {
            console.log('Subscription response mystery:', response);

            this.loader = false;
            this.openStripeModal({ ...response.results, ...body });
          } else {
            this.loader = false;
            this.matSnackBar.open(
              response.message ||
                'Failed to initiate subscription. Please try again.',
              'Close',
              { duration: 5000 }
            );
          }
        },
        error: (error: any) => {
          this.loader = false;
          const errorMessage =
            error?.error?.message ||
            'An error occurred while initiating subscription.';
          this.matSnackBar.open(errorMessage, 'Close', { duration: 5000 });
        },
      });
  }

  private openStripeModal(dataObj: any): void {
    console.log('openStripeModal dataObj mystery:', dataObj);

    const dialogRef = this.dialog.open(MysteryStripeModal, {
      panelClass: ['custom-modalbox', 'stripe-modalbox'],
      data: {
        dataObj: dataObj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('AuthGuard: Stripe Modal closed with result:', result);
    });
  }

  quarters = [
    {
      title: 'Quarter 1',
      season: 'Spring Equinox',
      signs: [
        { name: 'Aries', start: '03-21', end: '04-19' },
        { name: 'Taurus', start: '04-20', end: '05-20' },
        { name: 'Gemini', start: '05-21', end: '06-20' },
      ],
    },
    {
      title: 'Quarter 2',
      season: 'Summer Solstice',
      signs: [
        { name: 'Cancer', start: '06-21', end: '07-22' },
        { name: 'Leo', start: '07-23', end: '08-22' },
        { name: 'Virgo', start: '08-23', end: '09-22' },
      ],
    },
    {
      title: 'Quarter 3',
      season: 'Autumn Equinox',
      signs: [
        { name: 'Libra', start: '09-23', end: '10-22' },
        { name: 'Scorpio', start: '10-23', end: '11-21' },
        { name: 'Sagittarius', start: '11-22', end: '12-21' },
      ],
    },
    {
      title: 'Quarter 4',
      season: 'Winter Solstice',
      signs: [
        { name: 'Capricorn', start: '12-22', end: '01-19' },
        { name: 'Aquarius', start: '01-20', end: '02-18' },
        { name: 'Pisces', start: '02-19', end: '03-20' },
      ],
    },
  ];

  formatMonthDay(date: Date): string {
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
      .getDate()
      .toString()
      .padStart(2, '0')}`;
  }

  getSignStatus(sign: {
    start: string;
    end: string;
  }): 'past' | 'active' | 'upcoming' {
    const current = this.currentMonthDay;
    const [startMonth, startDay] = sign.start.split('-').map(Number);
    const [endMonth, endDay] = sign.end.split('-').map(Number);

    const start = new Date(this.today.getFullYear(), startMonth - 1, startDay);
    let end = new Date(this.today.getFullYear(), endMonth - 1, endDay);

    // Handle wraparound for Capricorn, etc.
    if (end < start) {
      end.setFullYear(end.getFullYear() + 1);
    }

    const currentDate = new Date(this.today);

    if (currentDate < start) return 'upcoming';
    if (currentDate > end) return 'past';
    return 'active';
  }

  openComingSoon() {
    const dialogRef = this.dialog.open(comingsoonModal, {
      panelClass: ['custom-modalbox'],
    });
  }

  openSlotSubscription(slot: any) {
    const dialogRef = this.dialog.open(SlotSubscriptionModal, {
      panelClass: ['custom-modalbox', 'dashboard_event_subscription_modal'],
      data: {
        slot: slot,
        userId: this.cookieData?.userinfo?._id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result || !result.success || !result.updates) {
        return;
      }

      const updates = result.updates;
      const wasSeriesSub = slot.subscribed_to_series === true;
      const isUnsubscribing = updates.subscribed === false;

      if (result.type === 'series') {
        this.calendarData.forEach((s: any) => {
          if (s.event_id === slot.event_id) {
            s.subscribed = updates.subscribed;
            s.subscribed_to_series = updates.subscribed_to_series;
          }
        });
      } else if (result.type === 'single' && isUnsubscribing && wasSeriesSub) {
        this.calendarData.forEach((s: any) => {
          if (s.event_id === slot.event_id) {
            s.subscribed_to_series = false;
            if (s._id === slot._id) {
              s.subscribed = false;
            }
          }
        });
      } else {
        const eventToUpdate = this.calendarData.find(
          (s: any) => s._id === slot._id
        );
        if (eventToUpdate) {
          eventToUpdate.subscribed = updates.subscribed;
          eventToUpdate.subscribed_to_series = updates.subscribed_to_series;
        }
      }

      this.matSnackBar.open(result.message, 'Ok', {
        duration: 5000,
      });

      this.cdr.detectChanges();
    });
  }
}

// << ------------------ Subscription Modal ------------------ >>

@Component({
  selector: 'MysterySubscriptionModal',
  templateUrl: './mystery-subscription-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class MysterySubscriptionModal {
  public prevData: any;

  constructor(
    public dialogRef: MatDialogRef<MysterySubscriptionModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar,
    private apiService: ApiservicesService
  ) {
    this.prevData = data;
  }

  public isLoading: boolean = false;

  ngOnInit() {}

  public unsubscribe() {
    this.isLoading = true;
    const payload = {
      subscription_id: this.prevData.subscription_id,
    };
    const endpoint = 'stripe/unsubscribe-stripe-mystery';

    this.apiService.getHttpDataPost(endpoint, payload).subscribe({
      next: (response: any) => {
        console.log('Unsubscribe response:', response);
        this.dialogRef.close(true);
        this.isLoading = false;
      },
      error: (error: any) => {
        const errorMessage = 'Failed to unsubscribe. Please try again.';
        this.matSnackBar.open(errorMessage, '', {
          duration: 5000,
        });
        this.isLoading = false;
        this.closeModal();
      },
    });
  }

  public closeModal() {
    this.dialogRef.close(false);
  }
}

// << ------------------ Stripe Mystery Comp ------------------ >>

@Component({
  selector: 'MysteryStripeModal',
  templateUrl: './mysteryStripeModal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule, CommonModule],
})
export class MysteryStripeModal implements OnInit {
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  clientSecret: string = '';
  public modalData: any = null;
  public stripeData: any = null;
  isLoading: boolean = false;
  public cookieData: any = {};
  setupIntentClientSecret: string = '';
  mode: 'payment' | 'setup' | 'noClientSecret' | undefined;

  constructor(
    public dialogRef: MatDialogRef<MysteryStripeModal>,
    private apiService: ApiservicesService,
    @Inject(MAT_DIALOG_DATA) public data: { index: any; item: any },
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public cookieService: CookieService,
    private cdr: ChangeDetectorRef
  ) {
    this.modalData = data;
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );
  }

  public userformdata: any = null;
  async ngOnInit() {
    console.log('this.modalData.dataObj_new mystery', this.modalData);

    if (!this.modalData || !this.modalData.dataObj) {
      console.error('Modal data or dataObj is missing!');
      this.mode = 'noClientSecret';
      return;
    }
    this.stripeData = this.modalData.dataObj;
    this.clientSecret = this.modalData.dataObj.clientSecret;
    this.setupIntentClientSecret =
      this.modalData.dataObj.setupIntentClientSecret;

    try {
      this.stripe = await loadStripe(environment.stripe_pub_key);
    } catch (error) {
      console.error('Error loading Stripe:', error);
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    if (!this.stripe) {
      console.error('Stripe.js failed to load.');
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    let clientSecretForElements: string | undefined;
    if (this.clientSecret) {
      console.log('Initializing for Payment Intent (clientSecret provided)');
      this.mode = 'payment';
      clientSecretForElements = this.clientSecret;
    } else if (this.setupIntentClientSecret) {
      console.log(
        'Initializing for Setup Intent (setupIntentClientSecret provided)'
      );
      this.mode = 'setup';
      clientSecretForElements = this.setupIntentClientSecret;
    } else {
      console.log('No clientSecret or setupIntentClientSecret found.');
      this.mode = 'noClientSecret';
    }
    this.cdr.detectChanges();

    if (
      (this.mode === 'payment' || this.mode === 'setup') &&
      clientSecretForElements
    ) {
      // It's often safer to wait for the next tick to ensure DOM is fully updated.
      // Using Promise.resolve().then() or setTimeout can help.
      Promise.resolve()
        .then(() => {
          if (this.stripe && clientSecretForElements) {
            // Re-check stripe due to closure
            console.log(
              `Attempting to mount Stripe Element for mode: ${this.mode}`
            );
            const paymentElementContainer = document.getElementById(
              'mystery-payment-element'
            );

            if (paymentElementContainer) {
              this.elements = this.stripe.elements({
                clientSecret: clientSecretForElements,
              });
              const paymentElement = this.elements.create('payment'); // 'payment' type element is used for both
              paymentElement.mount('#mystery-payment-element');
              console.log(
                `Successfully mounted Stripe Element for mode: ${this.mode}`
              );
            } else {
              console.error(
                `ERROR: #mystery-payment-element not found in DOM for mode: ${this.mode} even after mode assignment and tick.`
              );
            }
          }
        })
        .catch((error) => {
          console.error('Error in Promise for mounting Stripe element:', error);
        });
    } else if (this.mode !== 'noClientSecret') {
      console.warn(
        `Stripe element will not be mounted. Mode: ${this.mode}, Client Secret for Elements: ${clientSecretForElements}`
      );
    }
  }

  async handleSubmit(event: Event) {
    console.log('handleSubmit called');

    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;

    try {
      let cookiebody = {
        customer_id: this.modalData.dataObj.customerId,
        subscription_id: this.modalData.dataObj.subscriptionId,
        user_id: this.modalData.dataObj.user_id,
        email: this.modalData.dataObj.customer_email,
        name: this.cookieData?.userinfo?.name,
      };

      this.cookieService.set(
        'mysteryStripeUserDetails',
        JSON.stringify(cookiebody),
        {
          path: '/',
        }
      );
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/mystery-stripe-success-page`,
        },
        redirect: 'always',
      });

      if (error) {
        this.matSnackBar.open(
          `Payment failed: ${error.message || 'Unknown error'}`,
          '',
          {
            duration: 5000,
          }
        );
        this.isLoading = false;
      }
    } catch (e) {
      this.matSnackBar.open(
        'An unexpected error occurred. Please try again.',
        '',
        { duration: 5000 }
      );
      this.isLoading = false;
    }
    // this.dialogRef.close('success');
  }

  async handleSetupSubmit(event: Event) {
    console.log('handleSetupSubmit called');

    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;

    let cookiebody = {
      customer_id: this.modalData.dataObj.customerId,
      subscription_id: this.modalData.dataObj.subscriptionId,
      user_id: this.modalData.dataObj.user_id,
      email: this.modalData.dataObj.customer_email,
      name: this.cookieData?.userinfo?.name,
    };

    this.cookieService.set(
      'mysteryStripeUserDetails',
      JSON.stringify(cookiebody),
      {
        path: '/',
      }
    );

    const result = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: `${window.location.origin}/mystery-stripe-success-page`,
      },
      redirect: 'always',
    });
  }
}

// << ------------------ Slot Subscription Modal ------------------ >>

@Component({
  selector: 'SlotSubscriptionModal',
  templateUrl: './slot-subscription-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class SlotSubscriptionModal {
  public dataAll: any;
  public slotData: any;
  public userId: string;
  public isLoading: boolean = false;
  public modalError: string = '';

  constructor(
    public dialogRef: MatDialogRef<SlotSubscriptionModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar,
    private apiService: ApiservicesService
  ) {
    this.dataAll = data;
    this.slotData = this.dataAll.slot;
    this.userId = this.dataAll.userId;
  }

  ngOnInit() {}

  async handleAction(
    action: 'subscribe' | 'unsubscribe',
    type: 'single' | 'series'
  ) {
    this.isLoading = true;
    this.modalError = '';

    let payload: any = {
      user_id: this.userId,
      event_id: this.slotData.event_id,
      action: action,
    };
    let newLocalState: { subscribed: boolean; subscribed_to_series: boolean };

    if (action === 'subscribe') {
      newLocalState =
        type === 'single'
          ? { subscribed: true, subscribed_to_series: false }
          : { subscribed: true, subscribed_to_series: true };

      payload.subscription_type = type === 'single' ? 'slot' : 'event';
      payload.subscribed_to_series = type === 'series';
      if (type === 'single') {
        payload.event_slot_id = this.slotData._id;
      }
    } else {
      newLocalState = { subscribed: false, subscribed_to_series: false };
      const wasSubscribedToSeries = this.slotData.subscribed_to_series || false;

      payload.subscription_type = type === 'single' ? 'slot' : 'event';
      payload.subscribed_to_series =
        type === 'single' ? wasSubscribedToSeries : true;
      if (type === 'single') {
        payload.event_slot_id = this.slotData._id;
      }
    }

    try {
      const apiCall$ = this.apiService.getHttpDataPost(
        'event/event-subscription',
        payload
      );
      const response: any = await lastValueFrom(apiCall$);

      this.dialogRef.close({
        success: true,
        type: type,
        updates: newLocalState,
        message: response.message || `Successfully ${action}d!`,
      });
    } catch (error: any) {
      this.modalError =
        error?.error?.message || `An unknown error occurred during ${action}.`;
      this.matSnackBar.open(this.modalError, 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar'],
      });
    } finally {
      this.isLoading = false;
    }
  }

  public closeModal() {
    this.dialogRef.close();
  }
}
